import { TipoContatoEnum } from 'core/features/auth/typings/user';
import { PessoaTipo } from 'core/features/pessoas/typings';

export enum TipoSexo {
  Masculino = "m",
  Feminino = "f",
  Outro = "o",
}

export enum EstadoCivilEnum {
  Solteiro = "solteiro",
  Casado = "casado",
  Viuvo = "viuvo",
  Divorciado = "divorciado",
  Separado = "separado",
}

export interface PessoaFisicaOuJuridica {
  documento: string;
  email: string | null;
  imagemUrl: string | null;
  nome: string | null;
  telefone: string | null;
  celular: string | null;
  nomeFantasia?: string | null;
  inscricaoEstadual?: string | null;
  inscricaoMunicipal?: string | null;
  cnaeId?: string;
  classificacaoTributariaId?: string;
  naturezaJuridicaId?: string;
  tipoPessoaJuridicaId?: string;
  contatos?: { id: string; conteudo: string; tipoContatoId: TipoContatoEnum }[];
  rg?: string;
  sexo?: TipoSexo;
  estadoCivil?: EstadoCivilEnum;
  dataNascimento?: string;
  pins?: string;

}

export interface PessoaFisicaOuJuridicaForm {
  id?: string;
  ativo: boolean;
  pessoa: PessoaFisicaOuJuridica;
  pessoaTipo?: PessoaTipo;
}